import { Button, Form, Alert } from 'react-bootstrap';
import { CustomInput } from 'components/UI/CustomInput';

export default function ContactUs({
  theme,
  contactName,
  setContactName,
  contactEmail,
  setContactEmail,
  contactPhone,
  setContactPhone,
  contactNotes,
  setContactNotes,
  onSubmit,
  onBack,
  submitting = false,
  success = false,
  error = null,
}) {
  if (success) {
    return (
      <div className="text-center">
        <h2 className="mb-2">Thanks!</h2>
        <p className="mb-4">We received your message and we’ll be in touch.</p>
        <Button onClick={onBack} className="rounded-4 w-100 py-3">
          Back to Sign In
        </Button>
      </div>
    );
  }

  return (
    <div className="w-100 p-3" style={{ maxWidth: 380 }}>
      <div className="mb-1">
        <h1 className="mb-2">Welcome!</h1>
        <div style={{ color: '#A0AEC0' }}>
          Enter your information so we can Contact you with information on how to create an account
        </div>
      </div>
      <div className="mb-3">
        <div className="py-1 mx-2">Name</div>

        <CustomInput
          value={contactName}
          callback={setContactName}
          type="text"
          placeholder="Name or Organization Name"
        />
      </div>

      <div className="mb-3">
        <div className="py-1 mx-2">Phone Number</div>

        <CustomInput
          value={contactPhone}
          callback={setContactPhone}
          type="text"
          placeholder="(555)555-5555"
        />
      </div>

      <div className="mb-3">
        <div className="py-1 mx-2">Email</div>

        <CustomInput
          value={contactEmail}
          callback={setContactEmail}
          type="text"
          placeholder="Email Address"
        />
      </div>

      <div className="mb-3">
        <div className="py-1 mx-2">Notes (optional)</div>

        <CustomInput
          value={contactNotes}
          callback={setContactNotes}
          textarea
          rows={4}
          placeholder="Enter any additional information"
        />
      </div>

      {error && (
        <div className="mt-2 text-danger" role="alert">
          {error}
        </div>
      )}

      <Button
        type="submit"
        onClick={onSubmit}
        className="w-100 rounded-4 py-3 mb-3"
        disabled={submitting || !contactName || !contactEmail || !contactPhone}
      >
        {submitting ? 'Sending...' : 'Send'}
      </Button>

      <div className="text-center">
        <button
          type="button"
          className="btn btn-link text-decoration-none px-0"
          style={{ color: theme?.fontColor, opacity: 0.8 }}
          onClick={onBack}
        >
          ← Back to Sign In
        </button>
      </div>
    </div>
  );
}
